module.exports = __webpack_public_path__ + "static/grid_flexible-680b389cfacba4f2687d9199df2a22a2.webm";